import * as React from "react";

import "./analytics-locale.scss";
import { AmericanPieChart }   from "./american-pie-chart/american-pie-chart";
import { AnalyticsCities }    from "./analytics-cities/analytics-cities";
import { AnalyticsStates }    from "./analytics-states/analytics-states";
import { AnalyticsZips }      from "./analytics-zips/analytics-zips";

const colorsFill = ['#0A4AA1', '#1979D2', '#249AF3', '#66B7F6', '#BCDFFB']

export const AnalyticsLocale = ({leadInteractions, unfilteredLeadInteractions, filters, setFilters, settings, blogs, routerHistory, userLevels, zipCodes, hasMultipleStateLeads, orderCounts}) => {
    return (
        <div className="analytics-locale-dznts3">
            <AmericanPieChart {...{leadInteractions, unfilteredLeadInteractions, colorsFill, filters, settings, blogs, routerHistory, userLevels, orderCounts}} />
            <AnalyticsStates {...{leadInteractions, zipCodes, hasMultipleStateLeads, filters, setFilters}}/>
            <AnalyticsCities {...{leadInteractions, colorsFill}} />
            <AnalyticsZips {...{leadInteractions, unfilteredLeadInteractions, colorsFill, settings, blogs}} />
        </div>
    )

}

export const analyticCountArray = (leadInteractions, key) => {
    const counted = leadInteractions.reduce((accumulator, object) => {
        const values = object[key]

        if(values) {
            Array.isArray(values)
            ?   values.forEach(value => {
                    accumulator[value] = (accumulator[value] || 0) + 1
                })
            :   accumulator[values] = (accumulator[values] || 0) + 1
        }
        return accumulator
    }, {})

    const countedArray = Object.entries(counted).map(([value, count]) => {
        return { [key]: value, count: count }
    })

    countedArray.sort((a, b) => b.count - a.count)

    return countedArray
}

export const analyticSummaryArray = (leadInteractions, countKey, groupKey, labelKey) => {
    const summary = {};
    leadInteractions.forEach(obj => {
        const uniqueValue = obj[groupKey];
        const groupValue = obj[countKey];
        const labelValue = obj[labelKey];
        if (!groupValue || !uniqueValue) return;
        if (!summary[groupValue]) {
            summary[groupValue] = {
                label: labelValue ?? groupValue,
                uniqueValues: new Set()
            };
        }
        summary[groupValue].uniqueValues.add(uniqueValue);
    });
    const summaryArray = Object.entries(summary).map(([group, data]) => ({
        key: group,
        label: data.label,
        count: data.uniqueValues.size
    }));
    summaryArray.sort((a, b) => b.count - a.count);
    return summaryArray;
};

export const analyticSum = (countedArray, displayMax = 3) => {
    let sum = 0
    const limit = countedArray.length < displayMax ? countedArray.length : displayMax
    for(let i = 0; i < limit; i++) {
        sum += countedArray[i].count
    }
    return sum
}